import React from 'react';
import PropTypes from 'prop-types';
import Button from 'wonderbly-components/lib/Button';
import './PaypalButton.scss';

export const PayPal = props => (
  <Button href={props.url} fullWidth className="button--paypal" {...props}>
    <span>PayPal</span>
  </Button>
);

PayPal.propTypes = {
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PayPal;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Checkout/PayPal/PayPal.js